import { NumberInput, maxValue } from "react-admin";
import React, { useMemo } from "react";

import { get } from "lodash";
import moment from "moment";
import { useFormState } from "react-final-form";
import { validate } from "../useValidation";

const isCompleted = (message = "ra.validation.not_fully_planned") => (
  value,
  values
) => {
  const {
    planning: { completed },
  } = validate(values);
  return !completed ? message : undefined;
};

const DurationInput = ({ minAllowedDate, maxAllowedDate, ...props }) => {
  const formState = useFormState();
  const maxDuration = useMemo(() => {
    const startDate = moment(get(formState.values, "start_date"));
    const endDate = maxAllowedDate.clone(); // const endDate = minAllowedDate.clone().add(36, "months");
    const maxDuration = endDate.diff(startDate, "months");
    return maxDuration;
  }, [formState.values, maxAllowedDate]);
  return (
    <NumberInput
      {...props}
      helperText="resources.executive-project-work-packages.fields.duration.help"
      validate={[maxValue(maxDuration), isCompleted()]}
    />
  );
};
export default DurationInput;
